import { getCurrencyOptions } from '@invoice-simple/common';

export const isSupportedCurrency = (currencyCode: string): boolean => {
  const supportedCurrencies = getCurrencyOptions();

  return !!supportedCurrencies.find(
    (currency) => currency.value.toUpperCase() === currencyCode.toUpperCase()
  );
};
